import { render } from "./TheDepositTip.vue?vue&type=template&id=70d0bdff&scoped=true&ts=true"
import script from "./TheDepositTip.vue?vue&type=script&lang=ts"
export * from "./TheDepositTip.vue?vue&type=script&lang=ts"

import "./TheDepositTip.vue?vue&type=style&index=0&id=70d0bdff&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d0bdff"]])

export default __exports__